/* eslint-disable @typescript-eslint/no-explicit-any */
const validImageDomains = [`storage.googleapis.com/papyrus_images`]

/**
 * Checks if image is on our storage
 */
export function isExternalImage(src: string) {
  return !validImageDomains.some((domain: string) => src?.includes(domain))
}

/**
 * Checks if image is not base64 or svg and is not in our storage
 * @param src The url of the image
 * @returns boolean indicating if is a third party image
 */
export function isThirdPartyImage(src: string) {
  const isBase64Image = /data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(
    src || ""
  )
  const isSvgImage = src.includes("data:image/svg+xml")
  return !isBase64Image && !isSvgImage && isExternalImage(src)
}

/**
 * Iterate through the TipTap JSON and return first image attributes.
 */
export function findFirstImage(json: any) {
  function traverse(node: any): any {
    if (node.type === "image" && node.attrs?.src) return node.attrs

    if (node.content) {
      for (const childNode of node.content) {
        const result = traverse(childNode)
        if (result) return result
      }
    }

    return null
  }

  if (json.content) {
    for (const node of json.content) {
      const result = traverse(node)
      if (result) return result
    }
  }

  return null
}

/**
 * Process all images on the JSON generated by TipTap.
 * It's a copy of the function with the same name on the frontend.
 * @param json: a json object generated by TipTap
 * @returns The modified JSON with the images processed and stored in our storage
 */
export async function uploadThirdPartyImages(
  json: any,
  processImage: (s: string) => Promise<
    | {
        src: string
        blurdataurl: string
        nextwidth: number
        nextheight: number
      }
    | undefined
  >
) {
  const content: any = json.content?.map(async (element: any) => {
    if (
      element &&
      element.type === "image" &&
      element.attrs?.src &&
      isExternalImage(element.attrs.src)
    ) {
      try {
        const attrs = await processImage(element.attrs.src)
        element.attrs = { ...attrs, alt: element.attrs.alt }
      } catch (e) {
        console.error(e)
      }
      return element
    } else if (Array.isArray(element.content))
      return uploadThirdPartyImages(element, processImage)
    else return element
  })

  return { ...json, content: await Promise.all(content) }
}
